<template>
  <v-dialog
    v-model="dialog"
    max-width="290"
  >
    <v-card color="error" dark>
      <v-card-title>Erro</v-card-title>
      <v-card-text class="text-left">{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "LoginError",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }
  }
}
</script>